import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ViewersService } from '../../../../services/viewers.service';
import { ConnectionService } from '../../../../services/connection.service';
import { CommonModule } from '@angular/common';
import { VRService } from '../../../../services/vr.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-stream-button',
  imports: [CommonModule],
  templateUrl: './stream-button.component.html',
  styleUrl: './stream-button.component.css'
})
export class StreamButtonComponent implements OnInit{
  streamingMessage = false;
  loadingStream = false;
  isStreaming = false;
  
  constructor( 
    private viewersService: ViewersService,
    private connectionService: ConnectionService,
    private vrService: VRService,
    private cdr: ChangeDetectorRef
  ){}

  ngOnInit(): void {
    firstValueFrom(this.vrService.getVRView()).then((response) => {
      if(response && response === this.viewersService.viewer3d.getViewId()){
        this.isStreaming = true;
        this.cdr.detectChanges();
      }
    })
  }

  public onStreamVr() {
    const view = this.viewersService.viewer3d.getViewId()!;
    this.loadingStream = true;
    this.cdr.detectChanges();
    this.connectionService.createVRView(view).then(
      (response) => {
        this.vrService.setVRView(this.viewersService.viewer3d.getViewId()!)
        this.streamingMessage = true;
        this.loadingStream = false;
        this.cdr.detectChanges();
      }
    );
  }
}
